export const chartOption = {
    // chartType = candle, ohcl, area, line, renko, kagi
    property: {
        width: 500,
        height: 400,
        chartType: "candle",
        minMainChartHeight: 250
    },

    generalOption: {
        currency: 'usd',
        nation: 'all',
        theme: 'LIGHT',
    },

    additionalChart: [
        {
            type: 'volume',
            show: true,
            height: 100
        },
        {
            type: 'MACD',
            show: false,
            fast: 12,
            slow: 26,
            signal: 9,
            heightRatio: 1.0,
            macdAppearance: {
                stroke: {
                    macd: "#FF0000",
                    signal: "#74D400",
                },
                fill: {
                    divergence: "#4682B4"
                },
            }
        },

        {
            type: 'ForceIndex',

            short: {
                show: false,
                heightRatio: 1
            },
            long: {
                show: false,
                term: 13,
                heightRatio: 1
            }
        },
        {
            type: 'RSI',
            show: false,
            windowSize: 14,
            overbought: 70,
            oversold: 30,
            heightRatio: 1
        },

        {
            type: 'ATR',
            show: false,
            windowSize: 14,
            heightRatio: 1
        },

        {
            type: 'Stochastics',

            slow: {
                show: false,
                windowSize: 14,
                kSize: 3,
                dSize: 3,
                kLineColor: '#74D400',
                dLineColor: '#EA2BFF',
                heightRatio: 1
            },
            fast: {
                show: false,
                windowSize: 1,
                kSize: 5,
                dSize: 3,
                kLineColor: '#74D400',
                dLineColor: '#EA2BFF',
                heightRatio: 1
            },


            full: {
                show: false,
                windowSize: 14,
                heightRatio: 1
            }
        },
    ],

    index: {
        sma: [
            { show: true, size: 5, color: '#c00000' },
            { show: true, size: 10, color: '#00b050' },
            { show: true, size: 20, color: '#db11b4' },
            { show: false, size: 60, color: '#0a29ae' },
            { show: false, size: 120, color: '#eb9900' },
            { show: false, size: 200, color: '#00b0f0' },
        ],
        wma: [
            { show: false, size: 5, color: '#c00000' },
            { show: false, size: 10, color: '#00b050' },
            { show: false, size: 20, color: '#db11b4' },
            { show: false, size: 60, color: '#0a29ae' },
            { show: false, size: 120, color: '#eb9900' },
            { show: false, size: 200, color: '#00b0f0' },
        ],
        ema: [
            { show: false, size: 5, color: '#c00000' },
            { show: false, size: 10, color: '#00b050' },
            { show: false, size: 20, color: '#db11b4' },
            { show: false, size: 60, color: '#0a29ae' },
            { show: false, size: 120, color: '#eb9900' },
            { show: false, size: 200, color: '#00b0f0' },
        ],
        tma: [
            { show: false, size: 5, color: '#c00000' },
            { show: false, size: 10, color: '#00b050' },
            { show: false, size: 20, color: '#db11b4' },
            { show: false, size: 60, color: '#0a29ae' },
            { show: false, size: 120, color: '#eb9900' },
            { show: false, size: 200, color: '#00b0f0' },
        ],

        BollingerBand: {
            show: true,
            top: "#964B00",
            middle: "#000000",
            bottom: "#964B00",
            fill: "#4682B4"
        },
        SAR: {
            show: false,
            accelerationFactor: 0.02,
            maxAccelerationFactor: 0.2,
            fill: {
                falling: "#4682B4",
                rising: "#15EC2E"
            }
        },
    },
};